<div class="container greyTextContainer">
  <h1>Privacy Policy</h1>

  <p>
    We need to know some things about you to provide quality services to you.
  </p>

  <p>
    ADIEM is committed making sure your information is kept private. This policy
    outlines our ongoing obligations to you in respect of how we manage your
    Personal Information. There are laws to make sure your information is kept
    private. These laws say:
  </p>
  <ul>
    <li>How we can collect information.</li>
    <li>How we store information.</li>
    <li>Who can see your information.</li>
    <li>What we do with your information.</li>
  </ul>

  <p>
    We have adopted the Australian Privacy Principles (APPs) contained in the
    Privacy Act 1988 (Cth) (the Privacy Act). The NPPs govern the way in which
    we collect, use, disclose, store, secure and dispose of your Personal
    Information.
  </p>

  <p>
    A copy of the Australian Privacy Principles may be obtained from the website
    of The Office of the Australian Information Commissioner at www.aoic.gov.au
  </p>

  <h2>What is Personal Information and why do we collect it?</h2>

  <p>
    We need your permission to collect information about you and to share your
    information. You do not have to give permission. Your information helps us
    provide good and safe services.
  </p>

  <p>
    We only ask for information we need. Examples of Personal Information we may
    collect include: NDIS numbers, birthdates, full names, addresses, email
    addresses, landline phone numbers and mobile phone numbers for NDIS
    participants, their nominees, their immediate family members as well as
    their support coordinators and their employees.
  </p>

  <p>
    This Personal Information is obtained in many ways including face to face
    interviews, written correspondence, by telephone, by email, or via our
    website www.adiem.com.au. We may also collect data from other publicly
    available sources, and from third parties.
  </p>

  <p>
    We collect your Personal Information for the primary purpose of providing
    our services to you, providing information to our clients and marketing. We
    may also use your Personal Information for secondary purposes closely
    related to the primary purpose, in circumstances where you would reasonably
    expect such use or disclosure. You may unsubscribe from our
    mailing/marketing lists at any time by contacting us in writing.
  </p>

  <p>
    When we collect Personal Information we will, where appropriate and where
    possible, explain to you why we are collecting the information and how we
    plan to use it. If you do not understand why we need your information, you
    can simply ask us. We will protect your information and only use it for the
    right reasons, and only show the right people.
  </p>

  <h2>Sensitive Information</h2>

  <p>
    Sensitive information is defined in the Privacy Act to include information
    or opinion about such things as an individual's racial or ethnic origin,
    political opinions, membership of a political association, religious or
    philosophical beliefs, membership of a trade union or other professional
    body, criminal record or health information.
  </p>

  <p>Sensitive information will be used by us only:</p>

  <ul>
    <li>For the primary purpose for which it was obtained, or</li>
    <li>
      For a secondary purpose that is directly related to the primary purpose,
      or
    </li>
    <li>We are very worried about your safety, or</li>
    <li>If the law requires us to share it.</li>
  </ul>
  <p>You can see your information too. Just ask us.</p>

  <h2>Third Parties</h2>

  <p>
    Where reasonable and practicable to do so, we will collect your Personal
    Information only from you. However, in some circumstances we may be provided
    with information by third parties. In such a case we will take reasonable
    steps to ensure that you are made aware of the information provided to us by
    the third party.
  </p>

  <h2>Disclosure of Personal Information</h2>

  <ul>
    <li>Third parties where you consent to the use or disclosure; and</li>
    <li>Where required or authorised by law.</li>
  </ul>

  <h2>Security of Personal Information</h2>
  <p>
    Your Personal Information is stored in a manner that reasonably protects it
    from misuse and loss and from unauthorized access, modification, or
    disclosure.
  </p>

  <p>
    When your Personal Information is no longer needed for the purpose for which
    it was obtained, we will take reasonable steps to destroy or permanently
    de-identify your Personal Information. However, most of the Personal
    Information is or will be stored in client files which will be kept by us
    for a minimum of 7 years.
  </p>

  <h2>Access to your Personal Information</h2>

  <p>
    You may access the Personal Information we hold about you and to update
    and/or correct it, subject to certain exceptions. If you wish to access your
    Personal Information, please contact us in writing.
  </p>

  <p>
    ADIEM will not charge any fee for your access request but may charge an
    administrative fee for providing a copy of your Personal Information.
  </p>

  <p>
    To protect your Personal Information, we may require identification from you
    before releasing the requested information.
  </p>

  <h2>Maintaining the Quality of your Personal Information</h2>

  <p>
    It is an important to us that your Personal Information is up to date. We
    will take reasonable steps to make sure that your Personal Information is
    accurate, complete, and up to date. If you find that the information we have
    is not up to date or is inaccurate, please advise us as soon as practicable
    so we can update our records and ensure we can continue to provide quality
    services to you.
  </p>

  <h2>Policy Updates</h2>
  <p>
    This Policy may change from time to time and will be available on this
    website.
  </p>

  <h2>Privacy Policy Complaints and Enquiries</h2>

  <p>
    If you have any queries or complaints about our Privacy Policy please
    contact us:
  </p>
  <ul>
    <li>Call the ADIEM office on 0407 838 657.</li>
    <li>Write to ADIEM at 4 O’Shannasy Street, MULGRAVE VIC 3170.</li>
    <li>
      Make a complaint
      <a href="/make-a-complaint"> here</a> via our website's complaints form.
    </li>
  </ul>

  <h2>
    You can contact the Office of the Australian Information Commissioner:
  </h2>

  <table>
    <tr>
      <td>web:</td>
      <td>www.oaic.gov.au</td>
    </tr>
    <tr>
      <td>email:</td>
      <td>enquiries&#64;oaic.gov.au</td>
    </tr>
    <tr>
      <td>post:</td>
      <td>
        GPO Box 5218 <br />
        Sydney NSW 2001
      </td>
    </tr>
    <tr>
      <td>phone:</td>
      <td>1300 363 992</td>
    </tr>
    <tr>
      <td>TTY:</td>
      <td>133 677</td>
    </tr>
    <tr>
      <td>Speak and Listen:</td>
      <td>1300 555 727</td>
    </tr>
  </table>

  <br />
  <p>Interpreters can also be arranged on 131 450.</p>

  <h2>Advocates can help you complain</h2>

  <p>
    The National Disability Advocacy Program can help you work with an advocate.
    You can email them at: disabilityadvocacy&#64;dss.gov.au
  </p>

  <p>Or write to:</p>

  <div class="decg">
    Disability, Employment and Carers Group <br>
    Department of Social Services<br>
    GPO Box 9820<br>
    Canberra ACT 2601
  </div>
  <br>
  <p>Or search "disability advocate" online.</p>

  <br>

  <div class="backButton">
    <button class="okBtn" mat-raised-button color="primary" (click)="back()">
      Back
    </button>
  </div>
</div>